<template>
  <v-layout
    v-if="!loading"
    row
    wrap
    class="nx-list"
  >
    <nx-list-item
      v-for="(item, key) in items"
      :key="item.id || key"
      v-bind="{ ...item, ...$attrs }"
      :sortable="sortable"
      :checked="checked || selectedItemsIds.includes(item.id)"
      @input:check="$emit($event ? 'input:check' : 'input:uncheck', item)"
      @click:item="$emit('click:item', item)"
      @input:add-filter="$emit('input:add-filter', $event)"
      @input:set-filter="$emit('input:add-filter', $event)"
    >
      <template #actions="slotProps">
        <slot
          name="item-actions"
          v-bind="{ item, ...slotProps }"
        />
      </template>
    </nx-list-item>
  </v-layout>

  <v-layout
    v-else
    row
    wrap
  >
    <nx-list-item-skeleton
      v-for="key in iterableLoadingItems"
      :key="key"
      class="pa-1"
      v-bind="$attrs"
    />
  </v-layout>
</template>

<script>
import NxListItem from '@/components/list/components/ListItem';
import NxListItemSkeleton from '@/components/list/components/ListItemSkeleton';

export default {
  name: 'NxList',
  components: {
    NxListItem,
    NxListItemSkeleton,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    selectedItemsIds: {
      type: Array,
      default: () => [],
    },
    checked: {
      type: Boolean,
    },
    sortable: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
    loadingItems: {
      type: Number,
      default: 8,
    },
  },
  computed: {
    iterableLoadingItems() {
      return Array.from((new Array(this.loadingItems).keys()));
    },
  },
};
</script>
